


export const routes={

    "home":"/",

    "pageNotFount":"/page-not-found",
    "auth":"/auth",
    "authProcess":"/auth/:pro",

    "logout":"/logout",
    "dashboard":"/dashboard",

    "editor":"/editor",
    "mapEditor":"/mapEditor",

    "dashboardRroute":"/dashboard/:route",
    "dashboardRroutePage":"/dashboard/:route/:id",

    "dashboardRroutes":{
        "buildings":"buildings",
        "maps":"maps",
        "assignedBuildings":"assigned-buildings",
        "assignedMaps":"assigned-maps",
        "activeMaps":"active-maps",
        "avatarEditor":"avatar-editor",
    },


    "api":{
        "login":"/auth/login",
        "lessons":"/lessons",
        "buildings":"/buildings",
        "meshes":"/meshes",
        "meshesByBuilding":"/meshes/by-building/:id",
        "meshesByThreeItemEditor":"/meshes/by-three-item-editor/:id",
        "uploadMaterial":"/materials/upload",
        "materials":"/materials",
        "images":"/images",
        "users":"/users",
        "responsible":"/responsible",
        "maps":"/maps",
        
        "mapEditor":"/maps/editor",
        "mapEditorCheckEdit":"/maps/editor/check-edit/:id",

        "threeItemEditor":"/three-item-editor",
        "threeItemEditorCheckEdit":"/three-item-editor/check-edit/:id",

        "academicYear":"/academic-year",
        "semesters":"/semesters",
        "courses":"/courses",
        "branches":"/branches",
        "students":"/students",
        "mapItems":"/map-items",
        "itemsOfMap":"/map-items/:id",
        "dashboard":"/dashboard",
        "avatarColor":"/avatar-color"
    
    },

    "ws":{
        "checkUser":{
            "publish":"/app/check-user",
            "subscribe":"/user/queue/user-data"
        },
        "checkMapAccess":{
            "publish":"/app/check-map-access/:id",
            "subscribe":"/user/queue/map-access"  
        },
        "liveMap":{
            "publish":"/app/live-map/:id",
            "subscribe":"/topic/live-map/:id"
        },
        "liveMapEvents":{
            "subscribe":"/topic/live-map-events/:id"
        }
    }
}